import { BasicRequest } from "./basicRequest";

export class UnlockUserRequest extends BasicRequest{

    public userId!:number;

    constructor(){
        super();
    }
}